var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-boundary"},[(!_vm.hasError)?_vm._t("default"):_c('MaintenanceView')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }